export const formatMileage = (mileage: number) => `${Math.round(mileage / 10) / 100} km`;
